var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"metric-list"},[_vm._l((_vm.visible),function(item){return _c('span',{key:item.metric_key + item.captured_at},[_vm._v(_vm._s(_vm.unavailable(item) ? '暂不可用' : _vm.format(item.value))+" "+_vm._s(item.display_name))])}),(!_vm.visible.length)?_c('span',{staticClass:"muted"},[_vm._v("等待数据")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }